import { create } from "zustand"
import { getAptUnitSizeAPI, saveAptUnitSizeAPI } from "@/apis/admin-api"

export const aptUnitSizeStore = create((set, get) => ({
  aptUnitSizeMap: null,
  palette: null,

  selectedDong: null,
  setSelectedDong: (selectedDong) => set({ selectedDong }),

  // TODO: 편집동안 사용할 것
  maxFloor: 10,
  setMaxFloor: (maxFloor) => set({ maxFloor }),
  maxHo: 4,
  setMaxHo: (maxHo) => set({ maxHo }),
  selectedSize: null,
  setSelectedSize: (selectedSize) => set({ selectedSize }),

  apiGetAptSize: async (kapt_code) => {
    const { palette, unit_map } = await getAptUnitSizeAPI({ kapt_code })
    set({ palette, aptUnitSizeMap: unit_map })
  },

  apiSaveAptUnitSize: async ({ kapt_code, dong, hos, palette }) => {
    const { success } = await saveAptUnitSizeAPI({ kapt_code, dong, hos, palette })

    if (success) await get().apiGetAptSize(kapt_code)
    return success
  },

  reset: () => {
    set({
      aptUnitSizeMap: null,
      palette: null,
      selectedDong: null,
      maxFloor: 10,
      maxHo: 4,
      selectedSize: null
    })
  }
}))
